// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.maintenance-collapsible {
  margin-bottom: 1.6rem;
}
.maintenance-collapsible .entry-column {
  padding-top: 0.8rem;
  padding-left: 2.4rem;
  padding-right: 2.4rem;
}
.maintenance-collapsible .entry-column:last-child {
  padding-bottom: 1.6rem;
}
.maintenance-collapsible .entry-column .title {
  color: #0059a4;
}
.maintenance-collapsible .switch-button {
  padding-left: 1.6rem;
  padding-bottom: 1.6rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
